import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FileSizeService {
    constructor(private readonly httpClient: HttpClient) {}

    /**
     * Graciously stolen from https://github.com/dimdenGD/url-file-size/blob/main/index.js so that it does not use dynamic
     * imports and can be simplified within TS implementation.
     *
     * @param url url string of the file to be inspected
     * @return Observable of the size of the referenced file, if successful
     */
    public getFileSize(url: string): Observable<number> {
        return this.httpClient
            .head(url, {
                observe: 'response',
                responseType: 'text',
            })
            .pipe(
                map((response: HttpResponse<string>) => {
                    const contentLength =
                        response.headers.get('Content-Length');

                    if (!contentLength) {
                        throw new Error('Content-Length header not found');
                    }

                    const size = Number.parseInt(contentLength, 10);

                    if (Number.isNaN(size)) {
                        throw new Error('Invalid Content-Length value');
                    }

                    return size;
                }),
                catchError((error) => {
                    return throwError(() => error);
                })
            );
    }
}
